module.exports = __webpack_public_path__ + "img/cardActiveBgImg.59f0e00.png";